module.exports = __webpack_public_path__ + "fonts/iconfont.34e2d31a.woff";